






import Vue from 'vue'
import VueMarkdown from 'vue-markdown'

type Data = { content : string }

export default Vue.extend({
    name: 'Home',
    props: {
        title : String,
        file : String
    },
    data() : Data {
        return {
            content: ""
        }
    },
    methods: {
        async loadContent() {
            this.content = (
                await import (`../assets/posts/${this.file}`)
            ).default;
        }
    },
    async created() {
        this.content = (
            await import (`../assets/posts/${this.file}`)
        ).default;
    },
    components: {
        VueMarkdown,
    },
    watch: {
        $route (to, from) {
            this.loadContent()
        }
    }
})
